// extracted by mini-css-extract-plugin
export default {"body":"Cgu_body__S-4mK","content":"Cgu_content__zP62F","quesContainer":"Cgu_quesContainer__fESlg"};